import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const container = styled('div')`
  padding: 20px;
  display: flex;
  flex-direction: row;
`;

const title = styled('div')`
  font-size: var(--ph-heading-one);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
  margin: 18px 50px 24px;
`;

const whiteBox = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: space-between;
  margin: 20px;
  width: 260px;
  height: 268px;
  border-radius: var(--ph-border-radius-sm);
  box-shadow: var(--ph-box-shadow-sm);
  background-color: var(--white);
`;

const whiteBoxText = styled('div')`
  font-size: var(--ph-heading-three);
  font-weight: 400;
  color: var(--black);
  margin: 0;
  padding: 0;
  margin-top: 10px;
`;

const icon = styled(Svg)`
  width: 25%;
  margin: 0 auto;
`;

export default {
  Container: container,
  Title: title,
  WhiteBox: whiteBox,
  WhiteBoxText: whiteBoxText,
  Icon: icon,
};
